<form [formGroup]="PolicyForm">

    <div class="modal-header">
        <span class="fs-4 fw-600">Añadir / Modificar Póliza</span>
    </div>
    <div class="panel-body">
        <div class="row my-2">
            <div class="mt-2 col-xl-3 col-lg-3 col-xs-12">
                Póliza N°<small class="text-danger"></small>
                <input type="text" class="form-control" formControlName="code" name="code" placeholder="Póliza">
            </div>
            <div class="mt-2 col-xl-9 col-lg-9 col-md-12 col-xs-12">
                Nombre Contratante / Empresa <small class="text-danger"></small>
                <ng-select class="custom" [items]="listOffices" bindLabel="name" bindValue="name"
                    (change)="setOffice($event)" formControlName="name"></ng-select>
            </div>
            <div class="mt-2 col-xl-3 col-lg-3 col-md-6 col-xs-6">
                RUT<small class="text-danger"></small>
                <label class="form-control">{{!PolicyForm.value.rut ? "-" : PolicyForm.value.rut | numberPipe}}</label>
            </div>
            <div class="mt-2 col-xl-3 col-lg-3 col-md-6 col-xs-6">
                DV <small class="text-danger"></small>
                <label class="form-control">{{!PolicyForm.value.dv ? "-" : PolicyForm.value.dv}}</label>
            </div>
            <div class="mt-2 col-xl-3 col-lg-3 col-xs-12">
                Fecha Renovación <small class="text-danger"></small>
                <input type="date" class="form-control" formControlName="startDate" name="contract"
                    placeholder="Fecha Renovación">
            </div>
            <div class="mt-2 col-xl-3 col-lg-3 col-xs-12">
                Tipo Coberturas <small class="text-danger"></small>
                <ng-select class="custom" [items]="listCoverages" bindLabel="name" bindValue="_id"
                    formControlName="coverageId" (change)="submit()"></ng-select>
            </div>
            <div formGroupName="coverage" class="mt-3 col-xl-6 col-lg-6 col-md-12 col-xs-12 d-flex justify-content-evenly align-items-center">
                <div class="form-check form-switch">
                    <input #checkAdditionals class="form-check-input" type="checkbox" role="switch"
                        id="checkAdditionals" formControlName="allowsDependents">
                    <label class="form-check-label" for="checkAdditionals">Acepta Cargas</label>
                </div>
                <div class="form-check form-switch">
                    <input #checkCapital class="form-check-input" type="checkbox" role="switch" id="checkCapital"
                        formControlName="allowUpgrade">
                    <label class="form-check-label" for="checkCapital">Capital Variable</label>
                </div>
                <div class="form-check form-switch">
                    <input #checkMissionary class="form-check-input" type="checkbox" role="switch" id="checkMissionary"
                        formControlName="missionary">
                    <label class="form-check-label" for="checkMissionary">Exclusivo Misioneros</label>
                </div>
                <div class="form-check form-switch">
                    <input #checkActive class="form-check-input" type="checkbox" role="switch" id="checkActive"
                        formControlName="enabled">
                    <label class="form-check-label" for="checkActive">Activo</label>
                </div>
            </div>
        </div>
        <hr>
        <app-collection [policy]="PolicyForm.value" [year]="year" [saveData]="saveData"></app-collection>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-danger btn-sm mx-3" (click)="cancel()"> Cancelar</button>
        <!-- @if(permissions?.search.save){ -->
        <button type="button" class="btn btn-primary btn-sm" [disabled]="PolicyForm.invalid" (click)="submit()">
            Guardar</button>
        <!-- } -->
    </div>


</form>